import React, { useEffect, useState } from 'react'
import Select from 'react-select'
import parse from 'url-parse'
import qs from 'querystringify'

import FilterSideBar from './filterSideBar'
import CollectionProducts from './collectionProducts'
import FilterInAllProducts from './filterInAllProducts'

const options = [
  { value: 'featured', label: 'Featured' },
  { value: 'new', label: 'New' },
  { value: 'price_low_to_high', label: 'Price: Low to High' },
  { value: 'price_high_to_low', label: 'Price: High to Low' },
]

const ShopAllFilter = ({ client }) => {
  const [products, setProducts] = useState()
  const [collections, setCollections] = useState()
  const [filter, setFilter] = useState({
    collection: null,
    collectionTitle: 'All',
    size: null,
    color: null,
  })
  const [isCollectionSpecificPage, setIsCollectionSpecificPage] = useState(
    false
  )
  const [sortOption, setSortOption] = useState(options[0])
  const [isFirstLoaded, setIsFirstLoaded] = useState(false)
  const [isSearchPage, setIsSearchPage] = useState(false)
  const [searchTitle, setSearchTitle] = useState()

  const searchProducts = (args) => {
    const productsQuery = client.graphQLClient.query((root) => {
      root.addConnection('products', { args }, (product) => {
        product.add('title')
        product.add('tags')
        product.add('handle')
        product.add('createdAt')
        // product.add('priceRange')
        product.add('availableForSale')
        product.add('onlineStoreUrl')
        product.add('options', (option) => {
          option.add('name')
          option.add('values')
        })
        product.addConnection(
          'collections',
          { args: { first: 1 } },
          (collection) => {
            collection.add('title')
          }
        )
        product.addConnection('images', { args: { first: 50 } }, (image) => {
          image.add('src')
        })
        product.addConnection(
          'variants',
          { args: { first: 50 } },
          (variant) => {
            variant.add('id')
            variant.add('title')
            variant.add('price')
            variant.add('compareAtPrice')
            variant.add('availableForSale')
          }
        )
        // product.add('tags');// Add fields to be returned
      })
    })

    client.graphQLClient.send(productsQuery).then(({ model, data }) => {
      // Do something with the products
      setIsSearchPage(true)
      setProducts(model.attrs.products)
      setFilter({
        ...filter,
        filter: null,
        size: null,
        color: null,
      })
    })
  }

  const getCollections = (
    query = {
      first: 150,
      reverse: false,
    }
  ) => {
    const collectionsQuery = client.graphQLClient.query((root) => {
      root.addConnection(
        'collections',
        { args: { first: 20 } },
        (collection) => {
          collection.add('title')
          collection.add('handle')
          collection.add('image', (image) => {
            image.add('src')
          })
          collection.add('descriptionHtml')
          collection.addConnection(
            'products',
            {
              args: query,
            },
            (product) => {
              product.add('title')
              product.add('tags')
              product.add('handle')
              product.add('createdAt')
              // product.add('priceRange')
              product.add('availableForSale')
              product.add('onlineStoreUrl')
              product.add('options', (option) => {
                option.add('name')
                option.add('values')
              })
              product.addConnection(
                'images',
                { args: { first: 50 } },
                (image) => {
                  image.add('src')
                }
              )
              product.addConnection(
                'variants',
                { args: { first: 50 } },
                (variant) => {
                  variant.add('id')
                  variant.add('title')
                  variant.add('price')
                  variant.add('compareAtPrice')
                  variant.add('availableForSale')
                }
              )
            }
          )
        }
      )
    })

    client.graphQLClient.send(collectionsQuery).then(({ model, data }) => {
      // Do something with the products
      let allProductsArr = []

      for (let i = 0; i < model.attrs.collections.length; i++) {
        for (let j = 0; j < model.attrs.collections[i].products.length; j++) {
          allProductsArr = [
            ...allProductsArr,
            {
              ...model.attrs.collections[i].products[j],
              firstCollectionTitle: model.attrs.collections[i].title,
            },
          ]
        }
      }

      const urlParsed = parse(window.location.href)
      const lastURLSegment = urlParsed.pathname.substr(
        urlParsed.pathname.lastIndexOf('/') + 1
      )

      if (lastURLSegment !== 'collections') {
        setIsCollectionSpecificPage(true)
        const collectionFiltered = model.attrs.collections.find(
          (x) => x.handle === lastURLSegment
        )
        setFilter({
          collection: collectionFiltered,
          collectionTitle: lastURLSegment,
          size: null,
          color: null,
        })
      } else {
        setFilter({
          ...filter,
          collectionTitle: 'All',
          filter: null,
          size: null,
          color: null,
        })
      }

      const uniqueProductsArr = allProductsArr.reduce((acc, current) => {
        const x = acc.find((item) => item.id === current.id)
        if (!x) {
          return acc.concat([current])
        } else {
          return acc
        }
      }, [])

      setProducts(uniqueProductsArr)
      setCollections(model.attrs.collections)
    })
  }

  useEffect(() => {
    window.scrollTo(0, 0)

    const urlParsed = parse(window.location.href)
    const queryParsed = qs.parse(urlParsed.query)

    if (queryParsed.query) {
      setSearchTitle(queryParsed.query)
      searchProducts({ first: 150, query: `title:*${queryParsed.query}*` })
    } else {
      getCollections()
    }
  }, [])

  useEffect(() => {
    if (collections && !isFirstLoaded) {
      setIsFirstLoaded(true)
      sortByFeatured()
    }
  }, [collections])

  const onFilterByCollection = (collection, collectionTitle) => {
    if (collection.title !== 'All') {
      setFilter({ collection, size: null, color: null, collectionTitle })
    } else {
      setFilter({
        collection: null,
        size: null,
        color: null,
        collectionTitle: 'All',
      })
    }
  }

  const onFilterByVariant = (option, value) => {
    setFilter({
      ...filter,
      [option]: value,
    })
  }

  const sortByFeatured = () => {
    let collectionsArr = []
    let allProductsArr = []

    for (let i = 0; i < collections.length; i++) {
      let productsArr = []
      let productsWithFeaturedArr = []
      for (let j = 0; j < collections[i].products.length; j++) {
        if (
          collections[i].products[j].tags.find((x) => x.value === 'Featured')
        ) {
          productsWithFeaturedArr = [
            ...productsWithFeaturedArr,
            {
              ...collections[i].products[j],
              firstCollectionTitle: collections[i].title,
            },
          ]
        } else {
          productsArr = [
            ...productsArr,
            {
              ...collections[i].products[j],
              firstCollectionTitle: collections[i].title,
            },
          ]
        }
      }
      const sortedProductsArr = [...productsWithFeaturedArr, ...productsArr]
      allProductsArr = [...allProductsArr, ...sortedProductsArr]
      collectionsArr = [
        ...collectionsArr,
        {
          ...collections[i],
          products: sortedProductsArr,
        },
      ]

      var pageURL = window.location.href
      var lastURLSegment = pageURL.substr(pageURL.lastIndexOf('/') + 1)
      if (lastURLSegment !== 'collections') {
        const collectionFiltered = collectionsArr.find(
          (x) => x.handle === lastURLSegment
        )
        setFilter({
          ...filter,
          collection: collectionFiltered,
          collectionTitle: lastURLSegment,
          size: null,
          color: null,
        })
      } else {
        setFilter({
          ...filter,
          collectionTitle: 'All',
          filter: null,
          size: null,
          color: null,
        })
      }
    }

    const uniqueProductsArr = allProductsArr.reduce((acc, current) => {
      const x = acc.find((item) => item.id === current.id)
      if (!x) {
        return acc.concat([current])
      } else {
        return acc
      }
    }, [])

    setCollections(collectionsArr)
    setProducts(uniqueProductsArr)
  }

  const sortByFeaturedOnSearchResults = () => {
    let productsArr = []
    let productsWithFeaturedArr = []
    for (let i = 0; i < products.length; i++) {
      if (products[i].tags.find((x) => x.value === 'Featured')) {
        productsWithFeaturedArr = [...productsWithFeaturedArr, products[i]]
      } else {
        productsArr = [...productsArr, products[i]]
      }
    }
    const sortedProductsArr = [...productsWithFeaturedArr, ...productsArr]
    setProducts(sortedProductsArr)
  }

  const onChangeSort = (option) => {
    setSortOption(option)

    switch (option.value) {
      case 'new':
        if (isSearchPage) {
          searchProducts({
            first: 150,
            query: `title:*${searchTitle}*`,
            sortKey: client.graphQLClient.enum('CREATED_AT'),
            reverse: false,
          })
        } else {
          getCollections({
            first: 150,
            sortKey: client.graphQLClient.enum('CREATED'),
            reverse: false,
          })
        }
        break
      case 'price_low_to_high':
        if (isSearchPage) {
          searchProducts({
            first: 150,
            query: `title:*${searchTitle}*`,
            sortKey: client.graphQLClient.enum('PRICE'),
            reverse: false,
          })
        } else {
          getCollections({
            first: 150,
            sortKey: client.graphQLClient.enum('PRICE'),
            reverse: false,
          })
        }
        break
      case 'price_high_to_low':
        if (isSearchPage) {
          searchProducts({
            first: 150,
            query: `title:*${searchTitle}*`,
            sortKey: client.graphQLClient.enum('PRICE'),
            reverse: true,
          })
        } else {
          getCollections({
            first: 150,
            sortKey: client.graphQLClient.enum('PRICE'),
            reverse: true,
          })
        }
        break
      case 'featured':
        if (isSearchPage) {
          sortByFeaturedOnSearchResults()
        } else {
          sortByFeatured()
        }
        break
      default:
        break
    }
  }

  useEffect(() => {
    if (document.getElementById('shopify-section-collection-thumbnails')) {
      if (filter.collectionTitle === 'All' && !filter.size && !filter.color) {
        document.getElementById(
          'shopify-section-collection-thumbnails'
        ).style.display = 'block'
      } else {
        document.getElementById(
          'shopify-section-collection-thumbnails'
        ).style.display = 'none'
      }
    }
  }, [filter])

  return (
    <div className='container'>
      {!products && (
        <div className='section-shop-all-filter ssc'>
          <div className='hide-mobile'>
            <div className='products-filter'>
              <div className='ssc-line mb w-20'></div>
            </div>
            <div className='products-wrapper'>
              <div className='filter-products'>
                <div className='ssc-line w-100 mb'></div>
                <div className='ssc-line w-70 mb'></div>
                <div className='ssc-line w-30 mb'></div>
                <div className='ssc-line w-80 mb'></div>
                <div className='ssc-line w-60 mb'></div>
              </div>
              <div className='products-list'>
                <div className='ssc-line w-30 mb'></div>
                <br />
                <div className='flex align-start justify-between mb'>
                  <div className='w-30'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                  <div className='w-30'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                  <div className='w-30'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                </div>
                <br />
                <div className='flex align-start justify-between'>
                  <div className='w-30'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                  <div className='w-30'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                  <div className='w-30'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className='show-mobile'>
            <div className='products-wrapper'>
              <div className='filter-products'>
                <div className='mobile-filter show-mobile'>
                  <div className='filter-top'>
                    <div className='ssc-line'></div>
                  </div>
                </div>
              </div>
              <div className='products-list'>
                <div className='ssc-line w-30 mb'></div>
                <br />
                <div className='flex flex-wrap align-start justify-between'>
                  <div className='w-50 pr mb'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                  <div className='w-50 pl mb'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                  <div className='w-50 pr mb'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                  <div className='w-50 pl mb'>
                    <div className='ssc-square mb'></div>
                    <div className='ssc-line w-80'></div>
                    <div className='ssc-line w-40'></div>
                    <div className='ssc-line w-60'></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {products && collections && !isSearchPage && (
        <div className='section-shop-all-filter'>
          {/* {filter.collectionTitle === 'All' &&
              !filter.size &&
              !filter.color && <Collections collections={collections} />} */}

          <div className='products-filter'>
            <p>Sort</p>
            <Select
              options={options}
              className='react-select-container'
              classNamePrefix='react-select'
              defaultValue={options[0]}
              value={sortOption}
              onChange={onChangeSort}
            />
          </div>

          <div className='products-wrapper'>
            <FilterSideBar
              products={products}
              collections={collections}
              isCollectionSpecificPage={isCollectionSpecificPage}
              onFilterByCollection={onFilterByCollection}
              onFilterByVariant={onFilterByVariant}
              filter={filter}
            />

            <div className='products-list'>
              {filter.collectionTitle !== 'All' && filter.collection && (
                <CollectionProducts
                  collection={filter.collection}
                  filter={filter}
                  isShowAll={true}
                />
              )}

              {filter.collectionTitle === 'All' && (
                <FilterInAllProducts filter={filter} allProducts={products} />
              )}
            </div>
          </div>
        </div>
      )}
      {products && isSearchPage && (
        <div className='section-shop-all-filter'>
          <h1>
            Showing {products.length} product results for "{searchTitle}"
          </h1>

          <div className='products-filter'>
            <p>Sort</p>
            <Select
              options={options}
              className='react-select-container'
              classNamePrefix='react-select'
              defaultValue={options[0]}
              value={sortOption}
              onChange={onChangeSort}
            />
          </div>

          <div className='products-wrapper'>
            <FilterSideBar
              products={products}
              onFilterByVariant={onFilterByVariant}
              filter={filter}
            />
            <div className='products-list'>
              <FilterInAllProducts filter={filter} allProducts={products} />
            </div>
          </div>
        </div>
      )}
    </div>
  )
}

export default ShopAllFilter
